import styled from 'styled-components';
import { Box } from '@components/Box';
import { Flex } from '@components/Flex';
import { TextPairing } from '@components/TextPairing';
import { CloudImage } from '@components/CloudImage';

export const SectionContainer = styled(Box)`
  width: 100%;
  position: relative;
`;

export const TextPairingContainer = styled(TextPairing)`
  .text-pairing-body {
    max-width: 450px;
  }
`;

export const StyledTextPairFlex = styled(Flex)`
  width: 100%;
  align-items: center;
`;

export const StyledBottomImage = styled(CloudImage)`
  transform: translate(5%, 0px);
`;
